import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { AppService } from '../app.service';
import { Category } from '../app.models';
import { SidenavMenuService } from '../theme/components/sidenav-menu/sidenav-menu.service';
import { MenuService } from '../service/menu.service';
import { GrupoMenu } from '../domain/grupo-menu';
import { Carrito } from '../domain/carrito';
import { DetalleCarrito } from '../domain/detalle-carrito';
import { ShoppingCartService } from '../service/shopping-cart.service';
import { GLOBAL } from '../global';
import { Imagen } from '../domain/imagen';
import { AuthService } from '../service/auth/auth.service';
import { NovedadService } from '../service/novedad.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [SidenavMenuService]
})
export class PagesComponent implements OnInit {
  
  public showBackToTop: boolean = false;
  @ViewChild('sidenav') sidenav: any;
  @ViewChild('sidenav1') sidenav1: any;
  public menu: Array<GrupoMenu>;
  public settings: Settings;

  public carrito: Carrito;
  public urlBucket: string = GLOBAL.URL_BUCKET;
  public imagenDefecto: Imagen = GLOBAL.IMAGEN_DEFECTO;
    

  constructor(public appSettings: AppSettings,
    public appService: AppService,
    public sidenavMenuService: SidenavMenuService,
    public menuService: MenuService,
    private authService: AuthService,
    public router: Router,
    public shoppingCartService: ShoppingCartService,
    private novedadService: NovedadService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.carrito = this.shoppingCartService.getCarrito();
    this.menuService.loadMenu(this.authService.getUser());
  }

  public changeTheme(theme) {
    this.settings.theme = theme;
  }

  public stopClickPropagate(event: any) {
    if(window.innerWidth < 960){
      event.preventDefault();
      event.stopPropagation();
    }
  }

  public scrollToTop() {
    var scrollDuration = 200;
    var scrollStep = -window.pageYOffset / (scrollDuration / 20);
    var scrollInterval = setInterval(() => {
      if (window.pageYOffset != 0) {
        window.scrollBy(0, scrollStep);
      }
      else {
        clearInterval(scrollInterval);
      }
    }, 10);
    if (window.innerWidth <= 768) {
      setTimeout(() => { window.scrollTo(0, 0) });
    }
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    ($event.target.documentElement.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.sidenav.close();
        if(this.sidenav1){
          this.sidenav1.close();
        }
      }
    });
    this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuService.getSidenavMenuItems(this.menuService.menu));
    this.novedadService.getCountNovedadesAdministrador();
    if(this.isAuthenticate())
      this.novedadService.getCountNovedadesByTerc(this.authService.getUser().jti);
  }

  public closeSubMenus() {
    if (window.innerWidth < 960) {
      this.sidenavMenuService.closeAllSubMenus();
    }
  }

  getTestCart() {
    this.carrito = this.appService.getCarrito();    
  }

  /**
   * Elimina un producto del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-21
   * @param product
   */
  public remove(product: DetalleCarrito) {
    // const index: number = this.appService.carrito.listSicaDetalleCarrito.indexOf(product);
    // if (index !== -1) {
    //   this.appService.carrito.listSicaDetalleCarrito.splice(index, 1);
    //   this.appService.carrito.valorTotal -= product.valorTotal * product.cantidad;
    //   this.appService.carrito.totalItems -= product.cantidad;
    //   this.appService.setCarrito(this.appService.carrito);

    //   if (this.authService.isAuthenticate()) {
    //     this.appService.updateCarrito(this.appService.carrito).subscribe();
    //   }
    // }
  }

  /**
   * Elimina un producto del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-21
   * @param product
   */
  public removeShopping(product: DetalleCarrito) {
    const index: number = this.shoppingCartService.carrito.listSicaDetalleCarrito.indexOf(product);
    if (index !== -1) {
      this.shoppingCartService.carrito.listSicaDetalleCarrito.splice(index, 1);
      this.shoppingCartService.carrito.valorTotal -= product.cantidad * Math.round(product.valorTotal + (product.valorTotal * product.valorIva / 100));
      this.shoppingCartService.carrito.totalItems -= product.cantidad;

      if (this.authService.isAuthenticate()) {
        this.shoppingCartService.setCarrito(this.shoppingCartService.carrito);
        this.shoppingCartService.updateCarrito(this.shoppingCartService.carrito).subscribe();
      } else {
        this.shoppingCartService.setCarritoNoLogin(this.shoppingCartService.carrito);
      }
    }
  }

  /**
   * Elimina todos los productos del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-21
   * @param product
   */
  public clear() {
    // if (this.authService.isAuthenticate()) {
    //   this.appService.carrito.totalItems = 0;
    //   this.appService.carrito.valorTotal = 0;
    //   this.appService.carrito.listSicaDetalleCarrito = [];
    //   this.appService.setCarrito(this.appService.carrito);
      
    //   if (this.authService.isAuthenticate()) {
    //     this.appService.updateCarrito(this.appService.carrito).subscribe();
    //   }
    // } else {
    //   let carrito = new Carrito();
    //   carrito.totalItems = 0;
    //   carrito.valorTotal = 0;
    //   carrito.listSicaDetalleCarrito = [];
    //   this.appService.setCarrito(carrito);
    //   this.appService.carrito = carrito;
    // }
  }

  /**
   * Elimina todos los productos del carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-21
   * @param product
   */
  public clearShopping() {
    let newCart: Carrito = this.shoppingCartService.getCarrito();
    newCart.listSicaDetalleCarrito = [];
    newCart.totalItems = 0;
    newCart.valorTotal = 0;
    newCart.valorIva = 0;

    this.shoppingCartService.carrito.carrId = newCart.carrId;
    this.shoppingCartService.carrito.tercId_SicaTercero = newCart.tercId_SicaTercero;
    this.shoppingCartService.carrito.costoEnvio = newCart.costoEnvio;
    this.shoppingCartService.carrito.estado = newCart.estado;
    this.shoppingCartService.carrito.fechaCreacion = newCart.fechaCreacion;
    this.shoppingCartService.carrito.fechaInicio = newCart.fechaInicio;
    this.shoppingCartService.carrito.fechaModificacion = newCart.fechaModificacion;
    this.shoppingCartService.carrito.totalItems = newCart.totalItems;
    this.shoppingCartService.carrito.usuarioCreador = newCart.usuarioCreador;
    this.shoppingCartService.carrito.usuarioModificador = newCart.usuarioModificador;
    this.shoppingCartService.carrito.valorIva = newCart.valorIva;
    this.shoppingCartService.carrito.valorTotal = newCart.valorTotal;
    this.shoppingCartService.carrito.listSicaDetalleCarrito = newCart.listSicaDetalleCarrito;    

    if (this.authService.isAuthenticate()) {
      this.shoppingCartService.setCarrito(this.shoppingCartService.carrito);
      this.shoppingCartService.updateCarrito(this.shoppingCartService.carrito).subscribe();
    } else {
      this.shoppingCartService.setCarritoNoLogin(this.shoppingCartService.carrito);
    }
  }

  /**
   * Verifica si un usuario se ha autenticado, y tiene un token válido.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  isAuthenticate() {
    return this.authService.isAuthenticate();
  }

  /**
   * Cierra la sesión del cliente.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  onLogout() {
    this.authService.logout();
    this.router.navigate(['/']);
    this.menuService.loadMenu(null);
    
    this.shoppingCartService.carrito.carrId = null;
    this.shoppingCartService.carrito.tercId_SicaTercero = null;
    this.shoppingCartService.carrito.costoEnvio = null;
    this.shoppingCartService.carrito.estado = null;
    this.shoppingCartService.carrito.fechaCreacion = null;
    this.shoppingCartService.carrito.fechaInicio = null;
    this.shoppingCartService.carrito.fechaModificacion = null;
    this.shoppingCartService.carrito.totalItems = 0;
    this.shoppingCartService.carrito.usuarioCreador = null;
    this.shoppingCartService.carrito.usuarioModificador = null;
    this.shoppingCartService.carrito.valorIva = null;
    this.shoppingCartService.carrito.valorTotal = 0;
    this.shoppingCartService.carrito.listSicaDetalleCarrito = [];
    this.shoppingCartService.setCarrito(this.shoppingCartService.carrito);
  }

  /**
   * Retorna el nombre del usuario de la sesión.
   *  
   * @author Frank Edward Daza González
   * @version 2018-11-08
   */
  getUserSessionName(): string {
    return this.authService.getUser().iss;
  }

  /**
   * Retorna el correo del usuario de la sesión.
   *  
   * @author Andrés Felipe Vargas López
   * @version 2018-11-14
   */
  getUserSessionMail(): string {
    return this.authService.getUser().sub;
  }

}